var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusInactive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1E1E1E"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.72.38c1.867 0 3.453.653 4.76 1.96s1.96 2.889 1.96 4.746c0 1.857-.653 3.444-1.96 4.76-1.307 1.316-2.889 1.974-4.746 1.974-1.857 0-3.444-.658-4.76-1.974C.658 10.53 0 8.943 0 7.086c0-1.857.658-3.44 1.974-4.746C3.29 1.033 4.872.38 6.72.38zM1.624 7.1c0 1.232.383 2.305 1.148 3.22l7.196-7.196c-.933-.765-2.016-1.148-3.248-1.148-1.419 0-2.623.5-3.612 1.498-.99.999-1.484 2.207-1.484 3.626zm5.096 5.096c1.419 0 2.627-.5 3.626-1.498.999-.999 1.498-2.198 1.498-3.598 0-1.213-.383-2.296-1.148-3.248L3.5 11.048c.915.765 1.988 1.148 3.22 1.148z",
    transform: "translate(-865.000000, -569.000000) translate(239.000000, 241.000000) translate(626.000000, 328.000000)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/status-inactive.bc03c29c3147eaa1a0ba5b7933566dd6.svg";